import * as Yup from 'yup';

export const packingSlipSchema = Yup.object().shape({
  code: Yup.string().required('Required'),
  packingSlipDate: Yup.string().min(2, 'Required').required('Required'),
  shipDate: Yup.string().min(2, 'Required').required('Required'),
  shipMethod: Yup.string()
    .min(0, 'Too Short!')
    .max(255, 'Too Long!')
    .required('Required'),
  customer: Yup.object({
    companyName: Yup.string().required('Required'),
  }),
});

export const TAB_ERROR_PREFIXES = {
  0: ['code', 'packingSlipDate', 'shipDate', 'shipMethod', 'customer'],
};
